export default __webpack_public_path__ + "static/media/Anvilstrike.93ec5f37.jpg";